export default "__VITE_ASSET__38582f47__"